import React, { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import { Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import '../Style/Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef(null);
  const linksRef = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Navbar animation on load
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(navRef.current,
        { y: -100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out'
        }
      );

      // Stagger animation for nav links
      gsap.fromTo(linksRef.current,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.05,
          delay: 0.3,
          ease: 'power3.out'
        }
      );
    }, navRef);

    return () => ctx.revert();
  }, []);

  const closeMenu = () => {
    setMenuOpen(false);
    setShowServicesDropdown(false);
    setShowCompanyDropdown(false);
  };

  const addToRefs = (el) => {
    if (el && !linksRef.current.includes(el)) {
      linksRef.current.push(el);
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} ref={navRef}>
      <div className="container">
        <div className="navbar-logo">
          <p className='Nav-heading'>Automotive Devices</p>
        </div>

        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX /> : <FiMenu />}
        </div>

        <ul className={`navbar-links ${menuOpen ? 'active' : ''}`}>
          <li ref={addToRefs}><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li ref={addToRefs}><Link to="/contact" onClick={closeMenu}>Contact</Link></li>

          <li ref={addToRefs}
            className="dropdown"
            onClick={() => setShowServicesDropdown(!showServicesDropdown)}
            onMouseEnter={() => window.innerWidth > 768 && setShowServicesDropdown(true)}
            onMouseLeave={() => window.innerWidth > 768 && setShowServicesDropdown(false)}
          >
            <span className="dropdown-toggle">Services ▾</span>
            {showServicesDropdown && (
              <ul className="dropdown-menu">
                <li><Link to="/service/PCB" onClick={closeMenu}>PCB Assembly</Link></li>
                <li><Link to="/service/Prototyping" onClick={closeMenu}>Prototyping Intro</Link></li>
                <li><Link to="/service/Fabrication" onClick={closeMenu}>PCB Fabrication</Link></li>
                <li><Link to="/service/Supply" onClick={closeMenu}>Supply Chain & Logistic</Link></li>
                <li><Link to="/service/System" onClick={closeMenu}>System/Box Build</Link></li>
              </ul>
            )}
          </li>

          <li ref={addToRefs}
            className="dropdown"
            onClick={() => setShowCompanyDropdown(!showCompanyDropdown)}
            onMouseEnter={() => window.innerWidth > 768 && setShowCompanyDropdown(true)}
            onMouseLeave={() => window.innerWidth > 768 && setShowCompanyDropdown(false)}
          >
            <span className="dropdown-toggle">Company ▾</span>
            {showCompanyDropdown && (
              <ul className="dropdown-menu">
                <li><Link to="/About" onClick={closeMenu}>About Us</Link></li>
                <li><Link to="/mission" onClick={closeMenu}>Mission</Link></li>
                <li><Link to="/customer-focus" onClick={closeMenu}>Customer Focus</Link></li>
                <li><Link to="/product-focus" onClick={closeMenu}>Product Focus & Expertise</Link></li>
                <li><Link to="/quality" onClick={closeMenu}>Quality System</Link></li>
              </ul>
            )}
          </li>

          <li ref={addToRefs}>
            <Link to="/login" className="login-button" onClick={closeMenu}>Login</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
